import { render, staticRenderFns } from "./ZipperMaterialEdit.vue?vue&type=template&id=6e5ccdbc&"
import script from "./ZipperMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./ZipperMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports